import styled from "styled-components";

import { Modal } from "components/Modal";

export const AllocationAmountModalContainer = styled(Modal)`
  .modal-dialog {
    max-width: 584px;

    .modal-content {
      padding: 0px 0px 30px 0px;
      .modal-body {
        padding: 0;
        margin-top: 0px;
      }

      .heading {
        display: flex;
        align-items: center;
        padding: 14px 15px;
        background-color: ${({ theme }) => theme.modal.bg.secondary};
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;

        .back-btn {
          cursor: pointer;
        }

        h2 {
          width: 100%;
          text-align: center;
          color: ${({ theme }) => theme.card.font.tertiary};
          font-size: 20px;
          font-weight: 500;
          margin-bottom: 0px;
        }
      }

      .spacing-wrapper {
        padding: 0px 30px;
      }

      .other {
        font-weight: 500;
        font-size: 16px;
        text-align: center;
        color: ${({ theme }) => theme.tab.color.quinary};
        margin-bottom: 30px;
      }

      .strategy-title {
        font-weight: 500;
        font-size: 16px;
        color: ${({ theme }) => theme.modal.heading.font.primary};
        text-align: left;
      }

      .input-wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .min-value {
        font-size: 13px;
        color: ${({ theme }) => theme.tab.color.quinary};
      }

      .account {
        text-align: center;
        margin-bottom: 30px;
        display: flex;
        justify-content: center;
        gap: 18px;

        .account-item {
          padding: 14px 10px;
          width: 251.5px;
          height: fit-content;
          background: ${({ theme }) => theme.card.bg.septenary};
          border: 1px solid ${({ theme }) => theme.input.border.color};
          border-radius: 10px;
          font-weight: 600;
          font-size: 14px;
          color: ${({ theme }) => theme.modal.subHeading.font.color};
          span {
            color: ${({ theme }) => theme.tab.color.quinary};
            font-size: 14px;
            font-weight: 400;
          }
        }

        h5 {
          font-weight: 500;
          font-size: 15px;
          color: ${({ theme }) => theme.card.font.tertiary};
        }
      }

      .rheostat {
        margin: 60px 0 12px 0;
      }

      .price-inputs-wrapper {
        display: flex;
        justify-content: space-between;

        div {
          font-weight: 500;
          font-size: 12px;
          color: ${({ theme }) => theme.global.extraInfo.font.color};
        }

        .min-price {
          color: ${({ theme }) => theme.global.color.senary};
        }
      }

      .negative-margin {
        margin-right: -22px;
        z-index: 3;
      }

      .allocation-price-input {
        margin-right: 10px;
        font-size: 14px;
        padding: 10px 15px 10px 28px;
        min-width: 110px;
        max-width: 130px;
        border: none;
        height: 41px;
        background: ${({ theme }) => theme.input.bg.tertiary};
        border-radius: ${({ theme }) => theme.constants.BORDER_RADIUS_25};
        border: 1px solid ${({ theme }) => theme.input.border.color};
        color: ${({ theme }) => theme.input.font.primary};

        &:focus {
          box-shadow: none;
          outline: none;
        }

        &:disabled {
          cursor: not-allowed;
        }
      }

      .percentage {
        font-size: 14px;
        font-weight: 500;
      }

      .error-msg {
        color: #dc3545;
        margin: 20px 0px 0px 0px;
        text-align: center;
        font-size: 14px;
      }

      .box-wrapper {
        background: #191b20;
        border: 1px solid ${({ theme }) => theme.input.border.color};
        border-radius: 6px;
        padding: 10px;
        margin-bottom: 18px;
        cursor: pointer;

        &.allocation-amount-box {
          width: 216px;
        }

        &.active {
          background: #0157ff;
          border: 1px solid ${({ theme }) => theme.global.extraInfo.font.color};

          .amount {
            color: ${({ theme }) => theme.global.extraInfo.font.color};
          }
        }

        h5 {
          color: ${({ theme }) => theme.global.extraInfo.font.color};
          font-weight: 500;
          font-size: 10px;
        }

        .amount {
          color: #9e9e9e;
        }
      }

      .recommended {
        font-weight: 400;
        font-size: 14px;
        line-height: 150%;
        color: ${({ theme }) => theme.global.extraInfo.font.color};
        opacity: 0.7;

        img {
          margin-left: 12px;
        }
      }

      .pct {
        display: flex;
        align-items: center;
        padding-left: 15px;
        height: 41px;
        min-width: 130px;
        width: 100%;
        background: ${({ theme }) => theme.input.bg.tertiary};
        border-radius: ${({ theme }) => theme.constants.BORDER_RADIUS_25};
        border: 1px solid ${({ theme }) => theme.input.border.color};
        margin-right: 10px;
        font-size: 14px;
        color: ${({ theme }) => theme.tab.color.quinary};
      }

      .pct-sub {
        text-wrap: nowrap;
        display: flex;
        align-items: center;
        font-size: 14px;
        color: ${({ theme }) => theme.input.font.primary};
      }

      .btn-continue {
        margin-top: 20px;
        padding: 0px 30px;
        button {
          height: 40px;
          padding: 0;
        }
      }
    }
  }

  .buying-power-alert {
    text-align: center;
    font-size: 12px;
    padding: 5px;
  }

  @media (max-width: 500px) {
    .modal-dialog .modal-content {
      .heading {
        h2 {
          font-size: 16px;
        }
        img {
          height: 15px;
        }
      }

      .input-wrapper {
        gap: 6px;
        align-items: flex-start;
        flex-direction: column;
        justify-content: flex-start;
      }

      .amount-input {
        flex-direction: row;
        align-items: center;
      }
    }
  }
`;

export const BrokerContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: center;
  padding: 10px 20px 20px;

  .broker-title {
    color: ${({ theme }) => theme.card.font.tertiary};
    font-size: 16px;
    font-weight: 500;
  }
  .broker-type {
    color: ${({ theme }) => theme.card.font.quaternary};
    font-size: 12px;
  }

  .broker-img {
    width: 35px;
    height: 35px;

    img {
      width: 35px;
      height: 35px;
    }
  }

  .broker-name {
    font-weight: 500;
    font-size: 14px;
    max-width: 160px;

    span {
      opacity: 0.6;
    }
  }

  .broker-type {
    opacity: 0.6;
    font-size: 12px;
  }
`;
